
import { Component, Vue } from "vue-property-decorator";
import { UserPermissions, FeaturesList } from "@/store/types";
import { Getter } from "vuex-class";
import { get } from "lodash";
import NavHeader from "@/components/NavHeader.vue";
import vSelect from "vue-select";
import { Datetime } from "vue-datetime";
import { formatDateMixin } from "@/mixins";
import ActivityLogTable from "@/components/activity-log/ActivityLogTable.vue";

Vue.mixin(formatDateMixin);

@Component({
	components: {
		"nav-header": NavHeader,
		Datetime,
		vSelect,
		ActivityLogTable
	}
})
export default class ActivityLogManagement extends Vue {
	$refs!: {
		filterModal: any;
	};

	@Getter getPermissions: any;
	@Getter("getFeaturesList") featuresList: FeaturesList;

	private MaxDateTime = new Date().toISOString();
	private TimeZone = "UTC";
	private FromDateTime = new Date().toISOString();
	private ToDateTime = new Date().toISOString();

	private tmpFromDate = new Date().toISOString();
	private tmpToDate = new Date().toISOString();

	private showLiveData = true;
	private filterApplied = false;

	private triggerUpdate = false;

	private CanViewActivityLogHistory = false;

	private CanViewActivityLogManagment = false;

	private ShowAdvancedSearch = false;

	created() {
		// setup permissions
		this.CanViewActivityLogHistory = this.getPermissions.canViewActivityLogHistory;
		this.CanViewActivityLogManagment = this.getPermissions.canViewActivityLogManagement;

		// if user does not have access take them to the event queue
		if (!this.isActivityLogEnabled || !this.CanViewActivityLogManagment) {
			this.$router.push("/event-queue");
		}

		// set timezone based on browser
		this.TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	}

	private onSetDate(dates) {
		if (dates) {
			this.FromDateTime = new Date(dates.minDate).toISOString();
			this.ToDateTime = this.showLiveData
				? new Date().toISOString()
				: new Date(dates.maxDate).toISOString();
		}
	}

	private setDateRange() {
		this.showLiveData = false;
		this.FromDateTime = this.tmpFromDate;
		this.ToDateTime = this.ShowAdvancedSearch
			? this.tmpToDate
			: this.tmpFromDate;

		// if our dates are the same we must be searching the same day, so search until the end of the day
		if (this.ToDateTime == this.FromDateTime) {
			let endofDay = new Date(this.ToDateTime);
			endofDay.setHours(23);
			endofDay.setMinutes(59);
			endofDay.setSeconds(59);

			this.ToDateTime = endofDay.toISOString();
		}

		this.filterApplied = true;
		this.triggerUpdate = true;
		this.$refs.filterModal.hide();
	}

	private resetLiveStatus() {
		this.showLiveData = !this.showLiveData;
		this.triggerUpdate = false;
	}

	private updateLiveStatus(status: boolean) {
		this.showLiveData = status;
	}

	public get isActivityLogEnabled() {
		return get(this.featuresList, ["ActivityLog"]);
	}
}
